import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ConservationTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ConservationTypeCreateDto,
  ConservationTypeDto,
  ConservationTypeExcelDownloadDto,
  ConservationTypeUpdateDto,
} from '../proxy/planning/dtos/conservation-type';
import { CONSERVATIONTYPE_CONFIG, CONSERVATIONTYPE_FIELDS } from './conservation-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-conservation-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ConservationTypeService, ConfirmationService],
  templateUrl: './conservation-type.html',
  styleUrl: './conservation-type.scss',
})
export class ConservationType extends BaseCrudComponent<
  ConservationTypeDto,
  ConservationTypeCreateDto,
  ConservationTypeUpdateDto,
  ConservationTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(ConservationTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('ConservationType', ids),
  };
  config = CONSERVATIONTYPE_CONFIG;
  fields = CONSERVATIONTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ConservationTypeDto): ConservationTypeUpdateDto {
    return {
      description: data.description,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ConservationType';
  }
}
